import axios from 'axios';
import { API_URL } from '../config/api';

const authHeaders = () => ({
  Authorization: `Bearer ${localStorage.getItem('token')}`,
  'Content-Type': 'application/json',
});

export const startDirectCall = async (channelId, label = 'Direct call') => {
  const response = await axios.post(
    `${API_URL}/livekit/direct-call`,
    { channelId, label },
    { headers: authHeaders() },
  );
  return response.data;
};

/** Caddy on :9443 with the livekit.workloop.chat certificate from wacs. */
export const LIVEKIT_SIGNAL_URLS = [
  'wss://livekit.workloop.chat:9443',
];

/** Signaling URL for LiveKitRoom. Never pass https:// — the client needs ws/wss. */
export const normalizeLiveKitUrl = (rawUrl) => {
  const raw = String(rawUrl || '').trim();
  if (!raw) return '';
  try {
    const forParse = raw
      .replace(/^wss:\/\//i, 'https://')
      .replace(/^ws:\/\//i, 'http://');
    const uri = new URL(forParse);
    const host = uri.hostname;
    let secure = uri.protocol === 'https:' || /^wss:/i.test(raw) || /^https:/i.test(raw);
    let port = uri.port ? Number(uri.port) : (secure ? 443 : 80);
    const hostLower = host.toLowerCase();
    if (hostLower === 'livekit.workloop.chat'
        || hostLower === 'workloop.chat'
        || hostLower === 'www.workloop.chat') {
      secure = true;
      host = 'livekit.workloop.chat';
      if (!uri.port || port === 443 || port === 8443) {
        port = 9443;
      }
    }
    const defaultPort = (secure && port === 443) || (!secure && port === 80);
    const origin = `${secure ? 'wss' : 'ws'}://${host}${defaultPort ? '' : `:${port}`}`;
    const path = uri.pathname && uri.pathname !== '/' ? uri.pathname : '';
    return `${origin}${path}`;
  } catch {
    if (raw.startsWith('https://')) return `wss://${raw.slice('https://'.length)}`;
    if (raw.startsWith('http://')) return `ws://${raw.slice('http://'.length)}`;
    return raw;
  }
};

/** Backend URL first, then known Caddy listeners. */
export const liveKitUrlCandidates = (rawUrl) => {
  const primary = normalizeLiveKitUrl(rawUrl);
  const urls = [];
  const add = (url) => {
    if (url && !urls.includes(url)) urls.push(url);
  };
  LIVEKIT_SIGNAL_URLS.forEach(add);
  add(primary);
  return urls;
};

export const fetchLiveKitToken = async ({ channelId, messageId, roomName }) => {
  const response = await axios.post(
    `${API_URL}/livekit/token`,
    { channelId, messageId, roomName },
    { headers: authHeaders() },
  );
  const data = response.data || {};
  const url = normalizeLiveKitUrl(data.url);
  return {
    ...data,
    url,
    urls: liveKitUrlCandidates(data.url || url),
  };
};

export const muteLiveKitParticipant = async ({
  channelId,
  messageId,
  roomName,
  identity,
  trackSid,
  muted = true,
  kind = 'audio',
}) => {
  const response = await axios.post(
    `${API_URL}/livekit/mute`,
    {
      channelId,
      messageId,
      roomName,
      identity,
      trackSid,
      muted,
      kind,
    },
    { headers: authHeaders() },
  );
  return response.data;
};
